import React, { Fragment } from 'react'
import { Loading } from '@myxplor/ui'

import { RecordListActions } from '../../ui/gov-actions'
import RecordDisplayList from '../../ui/record-display-list'
import LocalAsyncStore from '../../local-async-store'

import Empty from './empty'
import registerManCon from './register-mancon-action'
import PersonnelSyncButton from './sync-button'
import './styles/ccs-personnel.css'

const name = ({ firstName, lastName }) => [firstName, lastName].join(' ')

const levelOneListFields = [
  {
    label: 'Name',
    fn: name,
  },
  {
    key: 'personID',
    label: 'Person ID',
  },
  {
    key: 'dateOfBirth',
    label: 'Date of birth',
  },
  {
    key: 'email',
    label: 'Email',
  },
]

const levelTwoListFields = [
  {
    key: 'mobile',
    label: 'Mobile',
  },
  {
    key: 'phone',
    label: 'phone',
  },
]

const RenderTopContent = ({
  provider_registration_id,
  refresh_personnel,
  available_actions,
  provider_id,
}) => (
  <div className="ccsPersonnel--sync-buttons">
    <RecordListActions
      options={[
        registerManCon({
          record: { provider_registration_id, available_actions },
          onComplete: () =>
            refresh_personnel(apiEndPoint({ provider_registration_id: provider_registration_id })),
        }),
      ]}
    />

    {provider_id ? (
      <PersonnelSyncButton
        provider_id={provider_id}
        provider_registration_id={provider_registration_id}
        onComplete={() =>
          refresh_personnel(apiEndPoint({ provider_registration_id: provider_registration_id }))
        }
      />
    ) : null}
  </div>
)

export const PersonnelList = ({
  personnel = { data: [], loading: false },
  provider_registration_id,
  available_actions,
  refresh_personnel,
  provider_id,
}) => {
  let { loading, data } = personnel

  if (loading) return <Loading>Loading CCS Personnel</Loading>
  if (data.length === 0)
    return (
      <Empty>
        <RenderTopContent
          provider_registration_id={provider_registration_id}
          refresh_personnel={refresh_personnel}
          available_actions={available_actions}
          provider_id={provider_id}
        />
      </Empty>
    )

  return (
    <Fragment>
      <RecordDisplayList
        {...{
          records: data,
          name: 'Management & Control Personnel',
          topContent: (
            <RenderTopContent
              provider_registration_id={provider_registration_id}
              refresh_personnel={refresh_personnel}
              available_actions={available_actions}
              provider_id={provider_id}
            />
          ),
          level1: levelOneListFields,
          level2: levelTwoListFields,
          recordBase: 'gov_record',
          showRaw: true,
          recordBadgesComponent: null,
        }}
      />
    </Fragment>
  )
}

const apiEndPoint = ({ provider_registration_id }) =>
  `/api/provider-registrations/${provider_registration_id}/personnel`

export default LocalAsyncStore('personnel', PersonnelList, apiEndPoint)



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/index.jsx